import {Tooltip} from "@mui/material";
import "./SharedComponents/sharedComponentsMedia.css";
import "./SharedComponents/sharedComponents.css";

function LinkTab(props) {
    let tooltip = false;
    let tooltipPlace = "bottom";
    if (props.tooltip ){
       tooltip = props.tooltip;
       if (props.tooltipPlace){
            tooltipPlace = props.tooltipPlace;
       }
    }
    let textClass = "";
    let cardClass = "";
    if (props.fiveTabs === true){
         textClass = "text-center primary-blue five-button-linktab-text";
         cardClass = " card mt-1 five-button-rounded-corners-linkTab py-0";
    }else{
        textClass = "text-center primary-blue linktab-text";
        cardClass = " card mt-2 rounded-corners-linkTab py-0";
    }
    
    if (props.validToComplete) {
     
        if (props.inputArr.completed === true){
            cardClass = cardClass + " bg-accent";
        }
        if (props.inputArr.selected === true){
            cardClass = cardClass + " link-tab-selected";
        }else{
            cardClass = cardClass + " link-tab";
        }
      
    }else{
        cardClass= cardClass + " bg-secondary rounded-corners-md link-tab"
    }
 
    return <>
        {tooltip ?
            <Tooltip title={props.tooltipText} arrow placement={tooltipPlace}>
                <div className={cardClass}>
                    <div className = "card-body rounded-corners-md px-0">
                        <h5 className={textClass}>{props.name}</h5>
                    </div>
                </div>
            </Tooltip>
        :
            <div className={cardClass}>
                <div className = "card-body rounded-corners-md px-0">
                <h5 className={textClass}>{props.name}</h5>
             </div>
            </div>
        }
               
    </>
  

}

export default LinkTab;